module.exports = __webpack_public_path__ + "static/media/document_back.a786e201.png";